
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 23.5v-9a1 1 0 011-1h21a1 1 0 011 1v9M10 11.5v-1a2 2 0 00-2-2H4a2 2 0 00-2 2v1m11-10a1 1 0 011.707-.707A1 1 0 0115 1.5a1.423 1.423 0 01-.312.89L13 4.5h2M18.5 3h-2v-.5a2 2 0 012-2v4m2-4v4m0-2H22a1 1 0 011 1v1m-4.5 9v-2m2.5-2h-5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.5 16a1 1 0 00-1 1v1.5h-2V17a1 1 0 00-2 0v4.5a1 1 0 102 0v-1h2v1a1 1 0 002 0V17a1 1 0 00-1-1zM3.5 3.5V4a2.5 2.5 0 105 0v-.5m0 0h-5V1.355a.509.509 0 01.335-.48c1.4-.5 2.93-.5 4.33 0a.509.509 0 01.335.48V3.5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    